import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider, useAuth } from "@/context/AuthContext";
import ProtectedRoute from "@/components/ProtectedRoute";
import Layout from "@/components/Layout";

import Landing from "@/pages/Landing";
import Login from "@/pages/Login";
import Register from "@/pages/Register";
import CheckEmail from "@/pages/CheckEmail";
import ForgotPassword from "@/pages/ForgotPassword";
import ResetPassword from "@/pages/ResetPassword";
import Diary from "@/pages/Diary";
import DiaryImport from "@/pages/DiaryImport";
import About from "@/pages/About";
import PrivacySecurity from "@/pages/PrivacySecurity";
import PrivacyPolicy from "@/pages/PrivacyPolicy";
import Terms from "@/pages/Terms";
import SearchPage from "@/pages/Search";
import Bookings from "@/pages/Bookings";
import BookingDetail from "@/pages/BookingDetail";
import Profile from "@/pages/Profile";
import MusicianView from "@/pages/MusicianView";
import Notifications from "@/pages/Notifications";
import Admin from "@/pages/Admin";
import Ensembles from "@/pages/Ensembles";
import EnsembleDetail from "@/pages/EnsembleDetail";
import NewEnsemble from "@/pages/NewEnsemble";
import Gigs from "@/pages/Gigs";
import NewGig from "@/pages/NewGig";
import GigDetail from "@/pages/GigDetail";
import Pricing from "@/pages/Pricing";
import BillingSuccess from "@/pages/BillingSuccess";
import ReferralRedirect from "@/pages/ReferralRedirect";
import Home from "@/pages/Home";
import Contacts from "@/pages/Contacts";
import RemoveMe from "@/pages/RemoveMe";
import Deps from "@/pages/Deps";
import DepBroadcast from "@/pages/DepBroadcast";
import DepDetail from "@/pages/DepDetail";
import DepReply from "@/pages/DepReply";
import WhatsNew from "@/pages/WhatsNew";
import Announcement from "@/pages/Announcement";
import AnnouncementUnsubscribe from "@/pages/AnnouncementUnsubscribe";

function HomeGate() {
  const { user } = useAuth();
  if (user === null) return null;
  if (user) return <Navigate to="/home" replace />;
  return <Landing />;
}

function ShellRoutes() {
  const Wrap = ({ children }) => (
    <ProtectedRoute>
      <Layout>{children}</Layout>
    </ProtectedRoute>
  );
  return (
    <Routes>
      <Route path="/" element={<HomeGate />} />
      <Route path="/login" element={<Login />} />
      <Route path="/register" element={<Register />} />
      <Route path="/check-email" element={<CheckEmail />} />
      <Route path="/r/:code" element={<ReferralRedirect />} />
      <Route path="/contacts/remove/:token" element={<RemoveMe />} />
      <Route path="/forgot-password" element={<ForgotPassword />} />
      <Route path="/reset-password" element={<ResetPassword />} />
      <Route path="/dep-reply/:token" element={<DepReply />} />
      <Route path="/about" element={<About />} />
      <Route path="/privacy-security" element={<PrivacySecurity />} />
      <Route path="/privacy-policy" element={<PrivacyPolicy />} />
      <Route path="/terms" element={<Terms />} />
      <Route path="/whats-new" element={<WhatsNew />} />

      <Route path="/diary" element={<Wrap><Diary /></Wrap>} />
      <Route path="/diary/import" element={<Wrap><DiaryImport /></Wrap>} />
      <Route path="/home" element={<Wrap><Home /></Wrap>} />
      <Route path="/contacts" element={<Wrap><Contacts /></Wrap>} />
      <Route path="/deps" element={<Wrap><Deps /></Wrap>} />
      <Route path="/deps/new" element={<Wrap><DepBroadcast /></Wrap>} />
      <Route path="/deps/:id" element={<Wrap><DepDetail /></Wrap>} />
      <Route path="/search" element={<Wrap><SearchPage /></Wrap>} />
      <Route path="/bookings" element={<Wrap><Bookings /></Wrap>} />
      <Route path="/bookings/:id" element={<Wrap><BookingDetail /></Wrap>} />
      <Route path="/profile" element={<Wrap><Profile /></Wrap>} />
      <Route path="/musicians/:id" element={<Wrap><MusicianView /></Wrap>} />
      <Route path="/notifications" element={<Wrap><Notifications /></Wrap>} />
      <Route path="/announcements/unsubscribe/:token" element={<AnnouncementUnsubscribe />} />
      <Route path="/announcements/:id" element={<Wrap><Announcement /></Wrap>} />
      <Route path="/ensembles" element={<Wrap><Ensembles /></Wrap>} />
      <Route path="/ensembles/new" element={<Wrap><NewEnsemble /></Wrap>} />
      <Route path="/ensembles/:id" element={<Wrap><EnsembleDetail /></Wrap>} />
      <Route path="/gigs" element={<Wrap><Gigs /></Wrap>} />
      <Route path="/gigs/new" element={<Wrap><NewGig /></Wrap>} />
      <Route path="/gigs/:id" element={<Wrap><GigDetail /></Wrap>} />
      <Route path="/pricing" element={<Pricing />} />
      <Route path="/billing/success" element={<Wrap><BillingSuccess /></Wrap>} />
      <Route path="/admin" element={
        <ProtectedRoute role="admin"><Layout><Admin /></Layout></ProtectedRoute>
      } />

      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
}

export default function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <ShellRoutes />
        <Toaster richColors position="top-center" />
      </BrowserRouter>
    </AuthProvider>
  );
}
